import lang from "@/views/modules/Emails/language/en";

let searchFieldsDef = {
    'subject': {
        label: lang.LBL_SUBJECT,
    },
    'fromname': {
        label: lang.LBL_FROM_EMAIL,
    },
    'to': {
        label: lang.LBL_TO_EMAIL,
    },
    'date_sent': {
        label: lang.LBL_DATE_SEND,
    },
    'status': {
        label: lang.LBL_STATUS,
    }
};
export default { searchFieldsDef }